import * as React from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import { Spacer } from 'design-system';
import { rem } from 'design-system/values';
import Squircle from 'design-system/Squircle';
import IconInfoTriangle from 'design-system/icons/IconInfoTriangle';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import TouchableBounce from 'utils/packages/TouchableBounce';
import { selectShouldShowMigrationToSecclBanner } from '../reducers/selectors';
import { isWeb } from '../../../constants';
const MigrationToSecclBanner = () => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const navigation = useMainStackNavigation();
    const { paddingHorizontalStyle } = useAppFrameDimensions(true);
    const shouldShowBanner = useAppSelector(selectShouldShowMigrationToSecclBanner);
    const handlePress = React.useCallback(() => {
        navigation.navigateDeprecated('MigrationToSecclIntro');
    }, []);
    // Web never shows Alpaca accounts
    if (!shouldShowBanner || isWeb)
        return null;
    return (<View style={[styles.mainContainer, paddingHorizontalStyle]}>
      <TouchableBounce onPress={handlePress}>
        <View style={styles.container}>
          <Squircle color={colors.elements.statusNegativeLight}>
            <IconInfoTriangle width={24} height={24} colorKey="negative"/>
          </Squircle>
          <Spacer w={16}/>
          <View style={styles.flex}>
            <Text Text-16>Keep investing in Emma</Text>
            <Spacer h={4}/>
            <Text Text-14 Negative>
              Tap to explore
            </Text>
          </View>
        </View>
      </TouchableBounce>
    </View>);
};
export default React.memo(MigrationToSecclBanner);
const styleSet = createStyleSheets((colors) => ({
    mainContainer: {
        backgroundColor: colors.cards.onDark,
        borderTopWidth: rem(1),
        borderTopColor: colors.borders.divider,
    },
    container: {
        padding: rem(16),
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    flex: {
        flex: 1,
    },
}));
